import AddressDisplay, { type AddressDisplayProps } from './AddressDisplay';

export type { AddressDisplayProps };
export default AddressDisplay;
